import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Input } from '../ui/input';
import { CheckCircle, Loader2, Users } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

// Buscador de matriculades registrades (mismo origen que Consulta de Deuda).
export const MatriculadoBuscador = ({ onSelect }) => {
  const [q, setQ] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [abierto, setAbierto] = useState(false);
  const [seleccionado, setSeleccionado] = useState(null);
  const reqId = useRef(0);

  useEffect(() => {
    if (!abierto || (q.length > 0 && q.length < 2)) return undefined;
    const t = setTimeout(async () => {
      const id = ++reqId.current;
      setLoading(true);
      try {
        const res = await axios.get(`${API}/api/antuar/usuarios-registrados`, {
          params: { buscar: q }, headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        if (id === reqId.current) setItems(res.data.usuarios || []);
      } catch { if (id === reqId.current) setItems([]); }
      if (id === reqId.current) setLoading(false);
    }, 250);
    return () => clearTimeout(t);
  }, [q, abierto]);

  const elegir = (u) => {
    setSeleccionado(u);
    setQ(u.nombre_completo);
    setAbierto(false);
    onSelect(u);
  };

  const limpiar = () => { setSeleccionado(null); setQ(''); onSelect(null); };

  return (
    <div className="relative" data-testid="matriculado-buscador">
      <label className="flex items-center gap-1 text-xs font-medium text-gray-700 mb-1">
        <Users className="w-3.5 h-3.5" /> Buscar matriculado registrado
      </label>
      <Input placeholder="Nombre, apellido, matrícula o DNI..." value={q} className="pr-8 bg-white"
        onChange={(e) => { setQ(e.target.value); setAbierto(true); }} onFocus={() => setAbierto(true)}
        onBlur={() => setTimeout(() => setAbierto(false), 150)} data-testid="matriculado-buscador-input" />
      {seleccionado && (
        <button type="button" onClick={limpiar} className="absolute right-2 top-[30px] text-gray-400 hover:text-gray-600"
          data-testid="matriculado-buscador-limpiar">✕</button>
      )}
      {abierto && (
        <div className="absolute z-20 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-60 overflow-y-auto">
          {loading ? (
            <div className="p-3 text-center text-gray-500 text-sm"><Loader2 className="w-4 h-4 animate-spin inline mr-2" />Cargando...</div>
          ) : items.length === 0 ? (
            <div className="p-3 text-center text-gray-500 text-sm">{q ? 'No se encontraron usuarios' : 'Escribí para buscar'}</div>
          ) : items.map(u => (
            <button key={u.id} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => elegir(u)}
              className="w-full p-2.5 text-left hover:bg-gray-50 border-b last:border-b-0 flex items-center justify-between"
              data-testid={`matriculado-opcion-${u.id}`}>
              <div>
                <p className="text-sm font-medium text-gray-900">{u.nombre_completo}</p>
                <p className="text-xs text-gray-500">Mat. {u.matricula} · DNI {u.documento}</p>
              </div>
              <CheckCircle className={`w-4 h-4 ${seleccionado?.id === u.id ? 'text-green-500' : 'text-transparent'}`} />
            </button>
          ))}
        </div>
      )}
      {seleccionado && (
        <p className="text-xs text-green-600 mt-1 flex items-center gap-1"><CheckCircle className="w-3.5 h-3.5" />Datos completados automáticamente</p>
      )}
    </div>
  );
};
